import { Box, Paper, Typography, Stack, Chip } from "@mui/material";
import {
    Hotel,
    DirectionsCar,
    LocalActivity,
    AccessTime,
    LocationOn,
    Schedule,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ProgramProductItem = ({ product, index }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const getIcon = () => {
        if (product.category_id === 3) return <Hotel fontSize="medium" sx={{ fontSize: 20 }} />;
        if (product.category_id === 2) return <DirectionsCar fontSize="medium" sx={{ fontSize: 20 }} />;
        return <LocalActivity fontSize="medium" sx={{ fontSize: 20 }} />;
    };

    const getColor = () => {
        if (product.category_id === 3) return "info";
        if (product.category_id === 2) return "warning";
        return "success";
    };

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                display: "flex",
                gap: 2,
                "@media print": {
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                },
                "&:hover": {
                    bgcolor: "action.hover",
                },
                alignItems: "center",
            }}
        >
            {/* Index */}
            <Box
                sx={{
                    minWidth: 40,
                    height: 40,
                    borderRadius: "50%",
                    bgcolor: `${getColor()}.main`,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                {index}
            </Box>

            {/* Details */}
            <Box sx={{ flex: 1 }}>
                <Stack direction="row" justifyContent={'space-between'} spacing={1} flexWrap="wrap" useFlexGap>
                    <Stack direction="row" spacing={1} sx={{flex:1}} alignItems="center" mb={0.5}>
                        {getIcon()}
                        <Typography variant="h6" fontWeight="600" sx={{ fontSize: '16px' }}>
                            {product.title[lang]}
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} sx={{flex:1, justifyContent: "flex-end"}} flexWrap="wrap" useFlexGap>
                        {product.time && (
                            <Chip
                                icon={<AccessTime sx={{ fontSize: 16 }} />}
                                label={product.time}
                                size="small"
                                variant="outlined"
                                sx={{ fontSize: '12px', fontWeight: 500 }}
                            />
                        )}
                        {product.pickup_time && (
                            <Chip
                                icon={<Schedule sx={{ fontSize: 16 }} />}
                                label={product.pickup_time}
                                size="small"
                                variant="outlined"
                                sx={{ fontSize: '12px', fontWeight: 500 }}
                            />
                        )}
                        {product.city && (
                            <Chip
                                icon={<LocationOn color="white" sx={{color: "#fff", fontSize: 16 }}/>}
                                label={product.city}
                                size="small"
                                variant="outlined"
                                sx={{ bgcolor: "rgba(30, 136, 229, 0.8)", color: "#fff", fontSize: '12px', fontWeight: 500 }}
                            />
                        )}
                        {product.units && (
                            <Chip
                                label={`${product.units} ${lang === 'ar' ? 'وحدة' : 'Units'}`}
                                size="small"
                                color={getColor()}
                                sx={{ fontSize: '12px', fontWeight: 500 }}
                            />
                        )}
                    </Stack>
                </Stack>
            </Box>
        </Paper>
    );
};

export default ProgramProductItem;
